import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import CubiscanLogo from '../../../pages/settings/premium-integrations/svgs/CubiscanLogo.svg';

import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { linkIDs } from '../../../services/link-service/links';
import { HelpArticleLink } from '../../../components/help-article-link';

import { ModalPortal } from '../../../components/modal-portal';

import style from './style.module.css';
import { messages } from './messages';

const listMessages = [messages.addDimensionersStep1, messages.addDimensionersStep2, messages.addDimensionersStep3];

export const SetupCubiscanModal = ({ onClose }) => {
  return (
    <ModalPortal onClose={onClose}>
      <Modal size='medium'>
        <ModalHeader>
          <FormattedMessage {...messages.title} />
        </ModalHeader>
        <ModalBody className={style['modal-body']}>
          <img alt='Cubiscan' className={style['cubiscan-icon']} src={CubiscanLogo} />
          <div className={style['body-spacing']}>
            <FormattedMessage
              {...messages.highVolumeMerchants}
              values={{
                a: (chunks) => <HelpArticleLink articleId={linkIDs.CubiscanDimensioners}>{chunks}</HelpArticleLink>,
              }}
            />
          </div>
          <ul className={style['add-dimensioners']}>
            <FormattedMessage {...messages.addDimensioners} />
            {listMessages.map((message) => (
              <li key={message.id}>
                <FormattedMessage {...message} />
              </li>
            ))}
          </ul>
          <div className={style['body-spacing']}>
            <FormattedMessage {...messages.needConnect} />
          </div>
          <div className={style['body-spacing']}>
            <FormattedMessage
              {...messages.downloadConnect}
              values={{
                a: (chunks) => <Link to='/settings/connect'>{chunks}</Link>,
              }}
            />
          </div>
        </ModalBody>
        <ModalFooter />
      </Modal>
    </ModalPortal>
  );
};

SetupCubiscanModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};
